import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaArrowRight,
  FaCode,
  FaRobot,
  FaBolt,
  FaCogs,
  FaDatabase,
  FaFilePdf,
  FaMobileAlt,
  FaShieldAlt,
  FaChartLine,
  FaCloud,
  FaStar,
} from "react-icons/fa";
import "./HomePageNew.css";

const HomePage = () => {
  const yearsInBusiness = new Date().getFullYear() - 1989;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const showcaseProjects = [
    {
      title: "ERP systém",
      subtitle: "Komplexný podnikový systém",
      description:
        "Skladové hospodárstvo, objednávky, dochádzka, plánovanie a reporting v jednej platforme. Viacjazyčné, viacúrovňové riešenie s notifikáciami.",
      technologies: ["React", "C#", "MSSQL", "SignalR"],
      image: "/erp2.png",
      link: "/produkty/erp",
      color: "#2563eb",
    },
    {
      title: "NAVIS",
      subtitle: "Inteligentná navigácia v areáloch",
      description:
        "Systém na riadenie a navigáciu vodičov kamiónov v skladových areáloch – od registrácie po obslúženie na rampe.",
      technologies: ["React", "C#", "SignalR"],
      image: "/vysyp2.png",
      link: "/produkty/vysyp",
      color: "#ef4444",
    },
    {
      title: "Lešenia",
      subtitle: "Kalkulačný systém",
      description:
        "Kalkulácie cien, zákazky, automatické PDF a maily zákazníkom. Všetko konfigurovateľné.",
      technologies: ["React", "C#", "MSSQL", "MUI"],
      image: "/lesenia0.png",
      link: "/produkty/lesenia",
      color: "#2a5a2a",
    },
    {
      title: "FastFood POS",
      subtitle: "Pokladničný systém",
      description:
        "Flexibilný POS pre reštauračné pobočky – klasická aj kiosková pokladňa, vernostný program, platobné terminály.",
      technologies: ["C#", "WPF", "MSSQL"],
      image: "/fastfoodpos3.png",
      link: "/produkty/fastfood-pos",
      color: "#f39c12",
    },
  ];

  const services = [
    {
      icon: FaCode,
      title: "Vývoj softvéru na mieru",
      description:
        "Od analýzy cez návrh až po nasadenie. Každé riešenie šijeme na mieru vašim procesom – žiadne zbytočné funkcie, len to, čo potrebujete.",
      link: "/produkty",
    },
    {
      icon: FaRobot,
      title: "Lokálne AI riešenia",
      description:
        "Implementácia AI priamo vo vašej infraštruktúre. RAG modely, multi-stage Text-to-SQL, chatboty nad vašimi dátami – bez odosielania dát tretím stranám.",
      link: "/ai-riesenia",
    },
    {
      icon: FaBolt,
      title: "Mini-aplikácie do 10 hodín",
      description:
        "Rýchle prototypy a mikro-nástroje, ktoré riešia konkrétny problém. Od nápadu k hotovému riešeniu za menej ako 10 hodín vývoja.",
      link: "/kontakt",
    },
    {
      icon: FaCogs,
      title: "Vylepšenie existujúceho riešenia",
      description:
        "Váš systém nestíha? Modernizujeme, optimalizujeme a rozširujeme existujúce aplikácie o nové funkcie a integrácie.",
      link: "/sluzby",
    },
  ];

  const aiCapabilities = [
    {
      icon: FaDatabase,
      title: "RAG modely",
      description:
        "AI, ktorá odpovedá na základe vašich interných dokumentov a dát.",
    },
    {
      icon: FaCode,
      title: "Text-to-SQL",
      description:
        "Pýtajte sa na vaše dáta priamo v ľubovoľnom jazyku.",
    },
    {
      icon: FaShieldAlt,
      title: "Lokálne LLM",
      description:
        "Žiadne dáta neopúšťajú vašu sieť. Bežia na vašich serveroch.",
    },
    {
      icon: FaRobot,
      title: "AI agenti",
      description:
        "Automatizované workflow – emaily, reporty, rozhodovanie.",
    },
  ];

  const stats = [
    { value: `${yearsInBusiness}+`, label: "rokov skúseností" },
    { value: "500+", label: "spokojných klientov" },
    { value: "15+", label: "produktov a riešení" },
    { value: "<10h", label: "mini-appky na mieru" },
  ];

  const references = [
    { name: "Quehenberger Logistics", logo: "/quehenberger.png" },
    { name: "CROCODILLE ČR", logo: "/crocodille.webp" },
    { name: "PIKARO TRADING", logo: "/pikaro-logo-web-03.png" },
    { name: "IQ servis", logo: "/iq_servis.jpg" },
    { name: "EGYM", logo: "/egym.png" },
    { name: "Imuna Pharm", logo: "/imuna.jpg" },
  ];

  const techStack = [
    "React", "C#", ".NET", "MSSQL", "SignalR", "MUI",
    "Python", "LangChain", "WPF", "REST API", "Docker",
  ];

  return (
    <div className="homepage">
      {/* ── Hero ── */}
      <section className="hp-hero">
        <div className="hp-hero-bg">
          <video className="hp-hero-video" autoPlay muted loop playsInline>
            <source src="/Video Project 1.mp4" type="video/mp4" />
          </video>
          <div className="hp-hero-overlay" />
        </div>

        <div className="hp-hero-content">
          <h1 className="hp-hero-title">
            Vyvíjame softvér,
            <br />
            <span className="hp-hero-highlight">ktorý posúva firmy vpred</span>
          </h1>
          <p className="hp-hero-description">
            Od podnikových systémov a lokálnej AI až po mini-aplikácie hotové za
            pár hodín. Už {yearsInBusiness} rokov digitalizujeme firmy na
            Slovensku a v Čechách.
          </p>
          <div className="hp-hero-actions">
            <Link to="/produkty" className="hp-btn hp-btn-primary">
              Naše riešenia <FaArrowRight />
            </Link>
            <Link to="/kontakt" className="hp-btn hp-btn-outline">
              Kontaktujte nás
            </Link>
          </div>
        </div>
      </section>

      {/* ── Stats ── */}
      <section className="hp-stats">
        <div className="hp-container">
          <div className="hp-stats-grid">
            {stats.map((stat, i) => (
              <div key={i} className="hp-stat-item">
                <div className="hp-stat-value">{stat.value}</div>
                <div className="hp-stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

        {/* ── AI, Mini-apps, Vývoj na mieru – 3 cards ── */}
      <section className="hp-duo">
        <div className="hp-container">
          <div className="hp-trio-grid">
            {/* AI & Data card */}
            <div className="hp-duo-card hp-duo-card--ai">
              <div className="hp-duo-header">
                <span className="hp-badge">AI & Data</span>
                <h2>Lokálna AI pre váš biznis</h2>
                <p>
                  AI riešenia bežiace na vašej infraštruktúre. Vaše dáta
                  zostávajú pod vašou kontrolou.
                </p>
              </div>
              <div className="hp-duo-ai-grid">
                {aiCapabilities.map((cap, i) => (
                  <div key={i} className="hp-duo-ai-item">
                    <div className="hp-duo-ai-icon">
                      <cap.icon />
                    </div>
                    <div>
                      <strong>{cap.title}</strong>
                      <span>{cap.description}</span>
                    </div>
                  </div>
                ))}
              </div>
              <Link to="/ai-riesenia" className="hp-btn hp-btn-primary">
                Viac o AI <FaArrowRight />
              </Link>
            </div>

            {/* Rýchly vývoj card */}
            <div className="hp-duo-card hp-duo-card--mini">
              <div className="hp-duo-header">
                <span className="hp-badge hp-badge-light">Rýchly vývoj</span>
                <h2>
                  Mini-aplikácia za{" "}
                  <span className="hp-duo-highlight">&lt;10h</span>
                </h2>
                <p>
                  Riešite niečo v Exceli alebo manuálne? Vytvoríme vám funkčný
                  webový nástroj rýchlo a na mieru.
                </p>
              </div>
              <div className="hp-duo-examples">
                <div className="hp-miniapp-tag">
                  <FaChartLine /> Dashboardy
                </div>
                <div className="hp-miniapp-tag">
                  <FaDatabase /> Interné nástroje
                </div>
                <div className="hp-miniapp-tag">
                  <FaFilePdf /> Generátory PDF
                </div>
                <div className="hp-miniapp-tag">
                  <FaMobileAlt /> Formuláre
                </div>
                <div className="hp-miniapp-tag">
                  <FaRobot /> AI asistenti
                </div>
              </div>
              <Link to="/kontakt" className="hp-btn hp-btn-primary">
                Mám záujem <FaArrowRight />
              </Link>
            </div>

            {/* Vývoj na mieru card */}
            <div className="hp-duo-card hp-duo-card--custom">
              <div className="hp-duo-header">
                <span className="hp-badge hp-badge-cyan">Na mieru</span>
                <h2>Vývoj softvéru na mieru</h2>
                <p>
                  Od analýzy cez návrh až po nasadenie. Šijeme riešenia
                  presne na vaše procesy.
                </p>
              </div>
              <div className="hp-custom-features">
                <div className="hp-custom-feature">
                  <FaCode />
                  <span>Webové aplikácie</span>
                </div>
                <div className="hp-custom-feature">
                  <FaCogs />
                  <span>ERP & CRM systémy</span>
                </div>
                <div className="hp-custom-feature">
                  <FaCloud />
                  <span>API & integrácie</span>
                </div>
                <div className="hp-custom-feature">
                  <FaShieldAlt />
                  <span>Bezpečnosť & audit</span>
                </div>
                <div className="hp-custom-feature">
                  <FaMobileAlt />
                  <span>Mobilné riešenia</span>
                </div>
              </div>
              <Link to="/produkty" className="hp-btn hp-btn-primary">
                Naše riešenia <FaArrowRight />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── Showcase / Naša práca ── */}
      <section className="hp-showcase">
        <div className="hp-container">
          <div className="hp-section-header hp-section-header--center">
            <span className="hp-badge">Portfólio</span>
            <h2>Naša práca</h2>
            <p>Reálne projekty, ktoré denne používajú stovky používateľov</p>
          </div>

          <div className="hp-showcase-grid">
            {showcaseProjects.map((project, i) => (
              <Link
                key={i}
                to={project.link}
                className="hp-showcase-card"
                style={{ "--accent": project.color }}
              >
                <div className="hp-showcase-number">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="hp-showcase-img">
                  <img src={project.image} alt={project.title} />
                </div>
                <div className="hp-showcase-body">
                  <div className="hp-showcase-meta">
                    {project.technologies.map((t, ti) => (
                      <span key={ti} className="hp-tech-tag">
                        {t}
                      </span>
                    ))}
                  </div>
                  <h3>{project.title}</h3>
                  <h4>{project.subtitle}</h4>
                  <p>{project.description}</p>
                  <span className="hp-showcase-link">
                    Zistiť viac <FaArrowRight />
                  </span>
                </div>
              </Link>
            ))}
          </div>

          <div className="hp-section-cta">
            <Link to="/produkty" className="hp-btn hp-btn-dark">
              Všetky riešenia <FaArrowRight />
            </Link>
          </div>
        </div>
      </section>

      {/* ── Services ── */}
      <section className="hp-services">
        <div className="hp-container">
          <div className="hp-section-header">
            <h2>S čím vám vieme pomôcť?</h2>
            <p>
              Zameriavame sa na vývoj softvéru – od enterprise systémov po
              rýchle micro-aplikácie a AI integrácie
            </p>
          </div>

          <div className="hp-services-grid">
            {services.map((service, i) => (
              <Link key={i} to={service.link} className="hp-service-card">
                <div className="hp-service-icon">
                  <service.icon />
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <span className="hp-card-arrow">
                  <FaArrowRight />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

    

      {/* ── Tech stack ── */}
      <section className="hp-tech">
        <div className="hp-container">
          <div className="hp-section-header">
            <h2>Technológie, ktoré používame</h2>
          </div>
          <div className="hp-tech-list">
            {techStack.map((tech, i) => (
              <div key={i} className="hp-tech-item">
                {tech}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Credibility ── */}
      <section className="hp-credibility">
        <div className="hp-container">
          <div className="hp-cred-layout">
            <div className="hp-cred-text">
              <h2>
                {yearsInBusiness} rokov skúseností. 500+ spokojných klientov.
              </h2>
              <p>
                Stojíme na pevných základoch. Od roku 1989 vyvíjame softvér pre
                firmy na Slovensku a v Čechách. Rozumieme podnikateľským cieľom
                a vieme ich premeniť na efektívne digitálne riešenia.
              </p>
              <div className="hp-cred-features">
                <div className="hp-cred-feature">
                  <FaShieldAlt />
                  <span>Spoľahlivosť a bezpečnosť</span>
                </div>
                <div className="hp-cred-feature">
                  <FaCloud />
                  <span>Vzdialená aj on-site podpora</span>
                </div>
                <div className="hp-cred-feature">
                  <FaCogs />
                  <span>Flexibilný prístup na mieru</span>
                </div>
              </div>
              <Link to="/o-nas" className="hp-btn hp-btn-dark">
                Viac o nás <FaArrowRight />
              </Link>
            </div>
            <div className="hp-clients-logos">
              {references.map((ref, i) => (
                <div key={i} className="hp-client-logo">
                  <img src={ref.logo} alt={ref.name} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA ──
      <section className="hp-cta">
        <div className="hp-container">
          <div className="hp-cta-inner">
            <h2>Máte nápad? Poďme ho realizovať.</h2>
            <p>
              Či už potrebujete enterprise systém, AI integráciu alebo rýchlu
              mini-appku – ozvite sa nám a do 24 hodín sa vám ozveme.
            </p>
            <div className="hp-cta-actions">
              <Link to="/kontakt" className="hp-btn hp-btn-white">
                Kontaktujte nás <FaArrowRight />
              </Link>
              <Link to="/produkty" className="hp-btn hp-btn-ghost">
                Pozrieť riešenia
              </Link>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default HomePage;
